<script setup>
import ModalWrapper from '@/modals/ModalWrapper';
import { watch, ref } from 'vue';
import { useKaleidicalStore } from '@/stores/kaleidical';

const emit = defineEmits(['close-modal']);

const props = defineProps({
    kaleidical: {
        type: Object,
        default: () => ({
            name: '',
        })
    },

    mode: {
        type: String,
        default: 'Create'
    }
});

const form = ref({
    ...props.kaleidical,
});

watch(() => props.kaleidical, (kaleidical) => {
    form.value = {
        name: kaleidical.name
    };
}, { immediate: true });

const { store, update } = useKaleidicalStore();

const save = async () => {
    const action = props.mode === 'Create' ? store : update;
    await action({
        ...form.value,
    });

    emit('close-modal');

};

const closeModal = () => {
    emit('close-modal');
};
</script>

<template>
<ModalWrapper>
    <template #header>Name Your Kaleidical</template>
    <form @submit.prevent="save">
        <StyledInput
            v-model="form.name"
            class="w-full"
            label="Name"
            name="name" />
    </form>

    <template #footer>
        <StyledSaveButton
            :hide-cancel="false"
            :modal="false"
            @save="save"
            @cancel="closeModal" />
        <!-- <StyledSaveButton modal @save="save" /> -->
    </template>
</ModalWrapper>
</template>
